import { ThresholdLineStyle, LineStyle, LineLabelStyle, ThresholdSpec, DeltaLabelStyle } from './models';
import { COMPARISON_MEASURE_COLUMN_NAME, COMPARISON_TIMESTAMP_COLUMN_NAME } from '../comparison/defaults';

export const defaultThresholdLineStyle = (): ThresholdLineStyle => {
  return {
    hidden: false,
    interactive: true,
    lineStyle: LineStyle.SOLID,
    deltaLabel: DeltaLabelStyle.HISTORICAL_DELTA,
    lineLabel: LineLabelStyle.NONE,
  };
};

export const defaultThresholdFeature = (): ThresholdSpec => {
  return {
    lines: [
      {
        measure: { column: COMPARISON_MEASURE_COLUMN_NAME },
        timestamp: { column: COMPARISON_TIMESTAMP_COLUMN_NAME },
        style: {
          ...defaultThresholdLineStyle(),
          hidden: true,
        },
      },
    ],
  };
};
